/**
 *
 * @param current
 * @param prev
 * @returns {null|number}
 */
const calcChange = (current, prev) => {
    const change = Math.round((100 * (current - prev)) / prev);
    return isNaN(change) ? null : change;
};
/**
 *
 * @param segmentStats
 * @returns {{total, code, highEngaged, EngagedChange: (null|number), totalChange: (null|number), highEngagedChange: (null|number), Engaged: *}}
 */
const prepFixelData = (segmentStats) => {
    return {
        code: segmentStats.code,
        total: segmentStats.current.total,
        totalChange: calcChange(segmentStats.current.total, segmentStats.previous.total),
        Engaged: segmentStats.current.basic,
        EngagedChange: calcChange(segmentStats.current.basic, segmentStats.previous.basic),
        highEngaged: segmentStats.current.high,
        highEngagedChange: calcChange(segmentStats.current.high, segmentStats.previous.high),
    };
};

/**
 *
 * @param fixelRes
 * @returns {{conversions: *, code: *, display: *, install_data: *, last_state_change: *, state: *, plan: *}|*}
 */
const prepFixelFullRes = (fixelRes) => {
    if (!fixelRes.TODAY) {
        return fixelRes;
    }

    const fullData = {
        code: fixelRes.TODAY[0].code,
        state: fixelRes.TODAY[0].state,
        display: fixelRes.TODAY[0].display,
        install_data: fixelRes.TODAY[0].install_data,
        plan: fixelRes.TODAY[0].plan,
        last_state_change: fixelRes.TODAY[0].last_state_change,
        conversions: fixelRes.LAST_30_DAYS[0].conversions,
    };

    for (const timeFrame in fixelRes) {
        fullData[timeFrame] = {
            conversions: fixelRes[timeFrame][0].conversions,
            fixelStats: prepFixelData({
                code: fixelRes[timeFrame][0].code,
                current: fixelRes[timeFrame][0].current,
                previous: fixelRes[timeFrame][0].previous,
            }),
        };
    }
    return fullData;
};
/**
 *
 * @param data
 * @returns {*}
 */
const prepPixels = (data) => {
    return data.map((pixel) => {
        return {
            name: `${pixel.name ? pixel.name : "Un-named"} (${pixel.id})`,
            id: pixel.id,
        };
    });
};

/**
 *
 * @param data
 * @returns {*}
 */
export const prepFBAccounts = (data) => {
    return data.map((account) => {
        return {
            name: `${account.name} (${account.account_id})`,
            id: account.id,
            pixels: account.adspixels ? prepPixels(account.adspixels.data) : [],
        };
    });
};

/**
 *
 * @param aud
 * @returns {string|string}
 */
const setStatus = (aud) => {
    switch (aud.status) {
        case "populating":
            return "Populating";
        case "ready":
            return aud.size >= 1000 ? "Ready" : "Populating";
        default:
            return "Inactive";
    }
};

/**
 *
 * @param fbAudiences
 * @returns {*[]|*}
 */
export const prepFBAudiences = (fbAudiences) => {
    if (!fbAudiences) return [];
    return fbAudiences.map((aud) => {
        return {
            aud_id: aud.aud_id,
            size: aud.size,
            code: aud.code,
            pixel: aud.pixel,
            pixel_name: aud.pixel_name,
            status: setStatus(aud),
            account: aud.account,
            account_name: aud.account_name,
            name: aud.name,
        };
    });
};

/**
 * @param name
 * @param data
 */
export const setToStorage = (name, data) => {
    localStorage.setItem(name,data);
}
/**
 * @param name
 * @returns {string}
 */
export const getFromStorage = (name) => {
    return localStorage.getItem(name)
}

export default prepFixelFullRes;